import { render, staticRenderFns } from "./SalesStatisticProduct.vue?vue&type=template&id=5af8ef2e&"
import script from "./SalesStatisticProduct.vue?vue&type=script&lang=ts&"
export * from "./SalesStatisticProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports